<template>
    <div class="container">
        <vue-headful
                title="Contact Requests - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">All Contact Requests</h3>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">Contact ID</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Message</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="contact in allContacts" :key="contact.id">
                                <td>
                                    <button @click="deleteContact(contact.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Contact"></button>
                                </td>
                                <th scope="row">
                                    {{contact.id}}
                                </th>
                                <td scope="row">
                                    <strong>{{contact.full_name}}</strong>
                                </td>
                                <td>
                                    {{contact.email}}
                                </td>
                                <td>
                                    {{contact.message}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card shadow pt-3 d-flex justify-content-center">
                    <pagination pagination="pagination"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";
import laravelPagination from "../components/LaravelPagination";

export default {
  data() {
    return {
      allContacts: {},
      pagination: {}
    };
  },
  mounted() {
    this.getAllContacts();
  },
  methods: {
    getAllContacts() {
      axios({
        method: "get",
        url:
          "admin/website/contact-requests?access_token=" +
          localStorage.getItem("access_token"),
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.allContacts = result.data.contacts.data;
            this.pagination = {
              currentPage: result.data.contacts.current_page,
              lastPage: result.data.contacts.last_page,
              firstPageUrl: result.data.contacts.first_page_url,
              lastPageUrl: result.data.contacts.last_page_url,
              nextPageUrl: result.data.contacts.next_page_url,
              previousPageUrl: result.data.contacts.prev_page_url,
              perPage: result.data.contacts.per_page,
              from: result.data.contacts.from,
              to: result.data.contacts.to,
              total: result.data.contacts.total
            };
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteContact(id) {
      axios({
        method: "delete",
        url: "admin/website/contact-requests/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Contact Request Deleted Successfully", "", "success");
            this.getAllContacts();
            console.log(result);
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful,
    pagination: laravelPagination
  }
};
</script>
<style>
</style>
